module.exports = __webpack_public_path__ + "media/images/flavours/icon-mineral_dark-456c4c69b0f0247a78fb9466f76fb500.png";